var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.52588 1.98205C6.73259 0.758091 5.37821 0.0136838 3.9197 0C2.46121 0.0136838 1.10684 0.758091 0.313543 1.98205C-0.104514 2.59557 -0.104514 3.40244 0.313543 4.01598C1.10639 5.24069 2.46084 5.98587 3.91972 6C5.37821 5.98632 6.73259 5.24191 7.5259 4.01795C7.94483 3.40397 7.94483 2.59602 7.52588 1.98205ZM6.71415 3.45972C6.10849 4.42037 5.05532 5.00647 3.9197 5.01489C2.7841 5.00648 1.73094 4.42037 1.12526 3.45972C0.936442 3.18232 0.936442 2.81767 1.12526 2.54028C1.73092 1.57963 2.78408 0.993533 3.9197 0.985113C5.05531 0.993517 6.10847 1.57963 6.71415 2.54028C6.90297 2.81767 6.90297 3.18232 6.71415 3.45972Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.91895 4.31446C4.64436 4.31446 5.23243 3.72639 5.23243 3.00098C5.23243 2.27556 4.64436 1.6875 3.91895 1.6875C3.19353 1.6875 2.60547 2.27556 2.60547 3.00098C2.60547 3.72639 3.19353 4.31446 3.91895 4.31446Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteEye);
export default __webpack_public_path__ + "static/media/white-eye.9763a4d4d0470b23ea424ba0ddf174c5.svg";
export { ForwardRef as ReactComponent };